 import CardValidation from "./Credit-Card-Validator/CardValidation";
function App() {
  return (
    <div>
      <CardValidation />
    </div>
  );
}
 export default App;
